import { otherIcons } from '@assets/icons/services/other';
import { googleIcons } from '@assets/icons/services/google';

export const serviceIcons = {
  ...googleIcons,
  ...otherIcons,
};
